'use client';

import { c as _c } from "react/compiler-runtime";
import { useState, useSyncExternalStore } from 'react';

// WHEN THE HERO FIRST APPEARED, on the `performance.now()` clock.
//
// The hero is server-rendered: on a full page load its loading veil is on
// screen from the first paint, while every timer here only starts once the
// bundle has downloaded and hydrated -- on a slow line or a slow CPU,
// seconds later. A cut-off measured from hydration would quietly add all
// of that on top. So a hydrating hero dates itself from navigation start
// (0), the moment that HTML began arriving.
//
// AN IN-APP NAVIGATION IS DIFFERENT. The document has been open for as
// long as the visitor has browsed, and the hero first appears when it
// mounts -- so it dates itself from then. React tells the two apart: only
// a hydrating render reads the server snapshot.
const subscribe = () => () => undefined;
export const useHeroClockStart = () => {
  const $ = _c(2);
  const isClientRender = useSyncExternalStore(subscribe, _temp, _temp2);
  let t0;
  if ($[0] !== isClientRender) {
    t0 = () => isClientRender ? performance.now() : 0;
    $[0] = isClientRender;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const [startMs] = useState(t0);
  return startMs;
};
export const msLeftSince = (startMs: number, durationMs: number): number => Math.max(0, startMs + durationMs - performance.now());
function _temp() {
  return true;
}
function _temp2() {
  return false;
}